function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  width: 28,
  height: 28,
  rx: 6,
  fill: "url(#accelerate_buying_svg__paint0_linear_447_8292)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 5.111a8.889 8.889 0 018.885 8.612l.004.277a.588.588 0 01-.73.57l-.151-.05-.791-.238.005-.282A7.222 7.222 0 1014 21.222l.282-.005.252.834.015.043a.588.588 0 01-.478.79L14 22.89A8.889 8.889 0 1114 5.11zm.45 8.89l.082.016 6.998 2.1a.55.55 0 01.232.918l-.076.064-1.654 1.146a.137.137 0 00-.05.165l.032.045 2.572 2.572a.551.551 0 01.064.703l-.064.077-.78.78a.551.551 0 01-.702.063l-.077-.063-2.591-2.589a.138.138 0 00-.152-.003l-.04.038-1.146 1.653a.55.55 0 01-.944-.063l-.037-.092-2.1-6.999a.413.413 0 01.351-.53h.082zM14 9a5 5 0 014.985 4.613l-1.78-.535a3.335 3.335 0 10-4.127 4.126l.535 1.781A5 5 0 0114 9z",
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "accelerate_buying_svg__paint0_linear_447_8292",
  x1: 0,
  y1: 0,
  x2: 0,
  y2: 28,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDCC50"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FCA000"
})));

var SvgAccelerateBuying = function SvgAccelerateBuying(props) {
  return React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgAccelerateBuying;